export default __webpack_public_path__ + "static/media/user.48d390cd.svg";